 // ✅ First FAQ open by default
document.addEventListener("DOMContentLoaded", function () {
  
  const faqItems = document.querySelectorAll(".faq-item");

  if (!faqItems.length) return;

  // ✅ First FAQ open by default
  faqItems[0].classList.add("active");
  faqItems[0].querySelector(".faq-answer").style.display = "block";

  faqItems.forEach(item => {
    const question = item.querySelector(".faq-question");

    question.addEventListener("click", function () {

      // ❌ Close all others
      faqItems.forEach(otherItem => {
        if (otherItem !== item) {
          otherItem.classList.remove("active");
          otherItem.querySelector(".faq-answer").style.display = "none";
        }
      });

      // ✅ Toggle current
      const answer = item.querySelector(".faq-answer");
      const isOpen = item.classList.contains("active");

      if (isOpen) {
        item.classList.remove("active");
        answer.style.display = "none";
      } else {
        item.classList.add("active");
        answer.style.display = "block";
      }
    });
  });

});
